import * as React from "react";
const SvgFiRrFaceSmilingHands = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-smiling-hands_svg__a)">
      <path
        fill="#062147"
        d="M10 10a1 1 0 0 1-1-1c0-1.054-.679-2-1-2s-1 .946-1 2a1 1 0 0 1-2 0c0-1.892 1.232-4 3-4s3 2.108 3 4a1 1 0 0 1-1 1m9-1c0-1.892-1.232-4-3-4s-3 2.108-3 4a1 1 0 0 0 2 0c0-1.054.68-2 1-2 .321 0 1 .946 1 2a1 1 0 0 0 2 0m-2.372 3.778a.993.993 0 0 0 .154-1.388 1.006 1.006 0 0 0-1.397-.178c-.01.008-1.073.788-3.385.788-2.275 0-3.34-.756-3.383-.787a1 1 0 0 0-1.245 1.565C7.527 12.903 8.973 14 12 14s4.473-1.097 4.628-1.222M23 10.983a1 1 0 0 0 .803-1.164A11.99 11.99 0 0 0 12 0 11.99 11.99 0 0 0 .198 9.819a1 1 0 1 0 1.967.361A9.99 9.99 0 0 1 12 2a9.99 9.99 0 0 1 9.835 8.181 1 1 0 0 0 1.165.802M19.963 12.5a.829.829 0 0 1 .585 1.413l-2.96 2.961 1.001 1.002 3.634-3.634a.825.825 0 0 1 1.17 0 .83.83 0 0 1 0 1.171l-3.63 3.631.984.985 1.84-1.84a.824.824 0 0 1 1.17 0 .82.82 0 0 1 .066 1.071c-.003.029-3.426 3.47-3.426 3.47a4.32 4.32 0 0 1-3.064 1.267c-1.43 0-2.858-.701-3.722-2.102-.425-.69-.612-1.505-.612-2.316v-3.58a1 1 0 0 1 2 0v1.119l4.377-4.377a.82.82 0 0 1 .585-.242zm-15.932 0c.212 0 .424.081.585.242l4.377 4.377V16a1 1 0 0 1 2 0v3.58c0 .811-.186 1.625-.612 2.316a4.34 4.34 0 0 1-3.722 2.102 4.32 4.32 0 0 1-3.064-1.267S.171 19.29.17 19.261a.818.818 0 0 1 .651-1.313c.212 0 .424.081.585.242l1.84 1.84.985-.985-3.632-3.632a.829.829 0 0 1 1.17-1.171l3.634 3.634 1.002-1.002-2.96-2.961a.829.829 0 0 1 .584-1.413z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-smiling-hands_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceSmilingHands;
